import { Helmet } from 'react-helmet-async';
import "./ChildrenProtection.css"
import "../../ParafiaWizytowka.css"
import Person from "./person/Person";
import {persons} from "../../data/childrenProtectionData.js"
import PdfPreview from "../../components/PdfPreview/PdfPreview.js";

const ChildrenProtection = () => {
  const getMetaDescription = () => {
    const responsiblePersons = persons.filter(person => person.role?.toLowerCase().includes('odpowiedzialny') || person.title?.toLowerCase().includes('ochrona'));
    
    let description = `Ochrona dzieci i młodzieży w parafii św. Urszuli Ledóchowskiej w Częstochowie. `;
    description += `Parafia przestrzega standardów ochrony małoletnich. `;
    
    if (responsiblePersons.length > 0) {
      const names = responsiblePersons.map(p => p.name).join(', ');
      description += `Osoby odpowiedzialne: ${names}. `;
    }
    
    description += `Zapoznaj się z procedurami i wytycznymi dotyczącymi bezpieczeństwa dzieci i młodzieży w naszej parafii.`;
    
    return description;
  };

  const getKeywords = () => {
    const names = persons.map(person => person.name.split(' ')[0]).filter(Boolean);
    return `ochrona dzieci, bezpieczeństwo małoletnich, standardy ochrony, procedury, ${names.join(', ')}, parafia Częstochowa, św. Urszula Ledóchowska, Wrzosowiak`;
  };

  return (
    <>
      <Helmet>
        <title>Ochrona dzieci i młodzieży – Parafia św. Urszuli Ledóchowskiej w Częstochowie</title>
        <meta name="description" content={getMetaDescription()} />
        <meta name="keywords" content={getKeywords()} />
        <meta property="og:title" content="Ochrona dzieci i młodzieży – Parafia św. Urszuli Ledóchowskiej" />
        <meta property="og:description" content="Standardy ochrony małoletnich w parafii św. Urszuli Ledóchowskiej. Procedury bezpieczeństwa, osoby odpowiedzialne i wytyczne dotyczące ochrony dzieci i młodzieży." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://swurszula.pl/ochrona-dzieci" />
        <meta property="og:locale" content="pl_PL" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Ochrona dzieci i młodzieży – Parafia św. Urszuli Ledóchowskiej" />
        <meta name="twitter:description" content="Parafia św. Urszuli Ledóchowskiej w Częstochowie – standardy ochrony małoletnich, procedury bezpieczeństwa i osoby odpowiedzialne." />
      </Helmet>

      <section>
        <h2 className="section-title">Ochrona dzieci i młodzieży</h2>
        <div>
          {persons.map((person, index) => (
            <Person key={index} person={person} />
          ))}
        </div>
        <PdfPreview/>
      </section>
    </>
  );
};

export default ChildrenProtection;